import { Injectable, NgZone } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { grpc } from '@improbable-eng/grpc-web';

import {
  ResetMingaContentRequest,
  ResetMingaContentResponse,
  UndoableAction,
} from '../content/cleanup_pb';
import {
  ContentInfoQuery,
} from '../content/common_pb';

import {
  ContentCleanup as __ContentCleanup,
} from '../content/cleanup_pb_service';

@Injectable({providedIn: 'root'})
export class ContentCleanup {

  constructor(private _ngZone: NgZone) {
  }

  delete(request: ContentInfoQuery): Promise<UndoableAction>;
  delete(request: ContentInfoQuery, metadata: grpc.Metadata): Promise<UndoableAction>;
  delete(request: ContentInfoQuery, callback: (err: any|null, response: UndoableAction, metadata: grpc.Metadata) => void): void;
  delete(request: ContentInfoQuery, metadata: grpc.Metadata, callback: (err: any|null, response: UndoableAction, metadata: grpc.Metadata) => void): void;

  delete(request: ContentInfoQuery, arg1?: grpc.Metadata|((err: any|null, response: UndoableAction, metadata: grpc.Metadata) => void), arg2?: (err: any|null, response: UndoableAction, metadata: grpc.Metadata) => void): Promise<UndoableAction>|void {
    let ret: any;
    let callback: any;
    let metadata: any;

    if(typeof arg1 === 'function') {
      callback = arg1;
    } else {
      metadata = arg1;
      callback = arg2;
    }

    if(!callback) {
      ret = new Promise<UndoableAction>((resolve, reject) => {
        callback = (err: any, response: any) => {
          if(err) reject(err);
          else resolve(response);
        };
      });
    }

    let responseMetadata: grpc.Metadata|null = null;

    let req = grpc.invoke(__ContentCleanup.Delete, {
      request: request,
      host: (<any>window).DEFAULT_ANGULAR_GRPC_HOST || 'https://' + location.hostname,
      metadata: metadata,
      onHeaders: headers => responseMetadata = headers,
      onMessage: response => this._ngZone.run(() => {
        callback(null, response, responseMetadata || new grpc.Metadata());
      }),
      onEnd: (code, msg, metadata) => this._ngZone.run(() => {
        if(code != grpc.Code.OK) {
          let err = new Error(msg);
          (<any>err).code = code;
          callback(err);
        }
      })
    });

    (<any>ret).cancel = () => req.close();
    return ret;
  }

  undoDelete(request: UndoableAction): Promise<UndoableAction>;
  undoDelete(request: UndoableAction, metadata: grpc.Metadata): Promise<UndoableAction>;
  undoDelete(request: UndoableAction, callback: (err: any|null, response: UndoableAction, metadata: grpc.Metadata) => void): void;
  undoDelete(request: UndoableAction, metadata: grpc.Metadata, callback: (err: any|null, response: UndoableAction, metadata: grpc.Metadata) => void): void;

  undoDelete(request: UndoableAction, arg1?: grpc.Metadata|((err: any|null, response: UndoableAction, metadata: grpc.Metadata) => void), arg2?: (err: any|null, response: UndoableAction, metadata: grpc.Metadata) => void): Promise<UndoableAction>|void {
    let ret: any;
    let callback: any;
    let metadata: any;

    if(typeof arg1 === 'function') {
      callback = arg1;
    } else {
      metadata = arg1;
      callback = arg2;
    }

    if(!callback) {
      ret = new Promise<UndoableAction>((resolve, reject) => {
        callback = (err: any, response: any) => {
          if(err) reject(err);
          else resolve(response);
        };
      });
    }

    let responseMetadata: grpc.Metadata|null = null;

    let req = grpc.invoke(__ContentCleanup.UndoDelete, {
      request: request,
      host: (<any>window).DEFAULT_ANGULAR_GRPC_HOST || 'https://' + location.hostname,
      metadata: metadata,
      onHeaders: headers => responseMetadata = headers,
      onMessage: response => this._ngZone.run(() => {
        callback(null, response, responseMetadata || new grpc.Metadata());
      }),
      onEnd: (code, msg, metadata) => this._ngZone.run(() => {
        if(code != grpc.Code.OK) {
          let err = new Error(msg);
          (<any>err).code = code;
          callback(err);
        }
      })
    });

    (<any>ret).cancel = () => req.close();
    return ret;
  }

  resetMingaContent(request: ResetMingaContentRequest): Promise<ResetMingaContentResponse>;
  resetMingaContent(request: ResetMingaContentRequest, metadata: grpc.Metadata): Promise<ResetMingaContentResponse>;
  resetMingaContent(request: ResetMingaContentRequest, callback: (err: any|null, response: ResetMingaContentResponse, metadata: grpc.Metadata) => void): void;
  resetMingaContent(request: ResetMingaContentRequest, metadata: grpc.Metadata, callback: (err: any|null, response: ResetMingaContentResponse, metadata: grpc.Metadata) => void): void;

  resetMingaContent(request: ResetMingaContentRequest, arg1?: grpc.Metadata|((err: any|null, response: ResetMingaContentResponse, metadata: grpc.Metadata) => void), arg2?: (err: any|null, response: ResetMingaContentResponse, metadata: grpc.Metadata) => void): Promise<ResetMingaContentResponse>|void {
    let ret: any;
    let callback: any;
    let metadata: any;

    if(typeof arg1 === 'function') {
      callback = arg1;
    } else {
      metadata = arg1;
      callback = arg2;
    }

    if(!callback) {
      ret = new Promise<ResetMingaContentResponse>((resolve, reject) => {
        callback = (err: any, response: any) => {
          if(err) reject(err);
          else resolve(response);
        };
      });
    }

    let responseMetadata: grpc.Metadata|null = null;

    let req = grpc.invoke(__ContentCleanup.ResetMingaContent, {
      request: request,
      host: (<any>window).DEFAULT_ANGULAR_GRPC_HOST || 'https://' + location.hostname,
      metadata: metadata,
      onHeaders: headers => responseMetadata = headers,
      onMessage: response => this._ngZone.run(() => {
        callback(null, response, responseMetadata || new grpc.Metadata());
      }),
      onEnd: (code, msg, metadata) => this._ngZone.run(() => {
        if(code != grpc.Code.OK) {
          let err = new Error(msg);
          (<any>err).code = code;
          callback(err);
        }
      })
    });

    (<any>ret).cancel = () => req.close();
    return ret;
  }

}

